import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const handlePhoneClick = () => {
    window.location.href = 'tel:+6282226648077';
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/6282226648077?text=Halo,%20saya%20butuh%20layanan%20AC%20segera.%20Mohon%20info%20lebih%20lanjut.', '_blank');
  };

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 lg:py-24 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-20 h-20 bg-primary rounded-full"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-secondary rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-accent rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            {/* Trust Badge */}
            <div className="inline-flex items-center bg-secondary/10 text-secondary px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Icon name="Award" size={16} className="mr-2" />
              Dipercaya 250+ Pelanggan
            </div>

            {/* Main Headline */}
            <h1 className="font-heading font-bold text-4xl lg:text-6xl text-foreground mb-6 leading-tight">
              Layanan AC Terpercaya{' '}
              <span className="text-primary">#1</span>{' '}
              di Bekasi
            </h1>

            {/* Subheadline */}
            <p className="text-xl lg:text-2xl text-muted-foreground mb-8 leading-relaxed">
              <span className="text-secondary font-semibold">Teknisi Bersertifikat</span> • 
              <span className="text-primary font-semibold"> Harga Transparan</span> • 
              <span className="text-accent font-semibold"> Garansi Puas</span>
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button
                variant="default"
                size="lg"
                onClick={handlePhoneClick}
                iconName="Phone"
                iconPosition="left"
                className="bg-accent hover:bg-accent/90 hover:scale-105 font-heading font-bold text-lg px-8 py-4 shadow-cta"
              >
                Hubungi Kami Sekarang
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={handleWhatsAppClick}
                iconName="MessageCircle"
                iconPosition="left"
                className="font-heading font-semibold text-lg px-8 py-4 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white"
              >
                Via WhatsApp
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-heading font-bold text-primary mb-1">10+</div>
                <div className="text-sm text-muted-foreground">Tahun Pengalaman</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-heading font-bold text-secondary mb-1">750+</div>
                <div className="text-sm text-muted-foreground">AC Diperbaiki</div>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center mb-1">
                  <span className="text-2xl lg:text-3xl font-heading font-bold text-accent mr-1">4.9</span>
                  <Icon name="Star" size={20} className="text-accent fill-current" />
                </div>
                <div className="text-sm text-muted-foreground">Rating Google</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-500">
              <img
                src="/assets/images/hero.png"
                alt="Teknisi AC profesional sedang memperbaiki unit AC"
                className="w-full h-80 object-cover rounded-xl"
              />
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-secondary text-white px-4 py-2 rounded-lg shadow-lg">
                <div className="flex items-center">
                  <Icon name="CheckCircle" size={16} className="mr-2" />
                  <span className="font-semibold text-sm">Garansi 2 Minggu</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-accent text-white px-4 py-2 rounded-lg shadow-lg">
                <div className="flex items-center">
                  <Icon name="Clock" size={16} className="mr-2" />
                  <span className="font-semibold text-sm">Respon 30 Menit</span>
                </div>
              </div>
            </div>

            {/* Background Decoration */}
            <div className="absolute -z-10 top-8 left-8 w-full h-full bg-primary/10 rounded-2xl"></div>
          </div>
        </div>

        {/* Phone Number Display */}
        <div className="mt-12 text-center lg:text-left">
          <p className="text-muted-foreground mb-2">Hubungi Sekarang:</p>
          <a 
            href="tel:6282226648077" 
            className="text-2xl lg:text-3xl font-heading font-bold text-accent hover:text-accent/80 transition-colors"
          >
            0822-2664-8077
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
